import { useEffect, useRef, useState } from "react";

interface MeterReading {
  meter_id: number;
  serial: string;
  cumulative: string;
  flow_rate: string;
  pressure: string;
  valve_open: boolean;
  timestamp: string;
}

export function useLiveMetrics(meterId: number) {
  const [reading, setReading] = useState<MeterReading | null>(null);
  const [connected, setConnected] = useState(false);
  const wsRef = useRef<WebSocket | null>(null);

  useEffect(() => {
    const wsBase = process.env.REACT_APP_WS_URL || "wss://meters.mutabletech.co.ke";
    const ws = new WebSocket(`${wsBase}/ws/meter/${meterId}/`);
    wsRef.current = ws;

    ws.onopen = () => setConnected(true);
    ws.onclose = () => setConnected(false);
    ws.onmessage = (e) => {
      try {
        setReading(JSON.parse(e.data));
      } catch {}
    };

    return () => ws.close();
  }, [meterId]);

  return { reading, connected };
}
